import moduleConfig from './module-config';
import netsSsoEnroll from './nets-sso-enroll';

export default angular
  .module('app.sso-enroll', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsSsoEnroll', netsSsoEnroll);
